import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const useStyles = makeStyles(theme => ({
  eventItem: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(1.25, 0),
    gap: 12,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  dateBox: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: 'rgba(240, 163, 28, 0.09)',
    border: '1px solid rgba(240, 163, 28, 0.14)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  dateDay: {
    fontSize: 14,
    fontWeight: 700,
    color: '#F0A31C',
    lineHeight: 1,
  },
  dateMonth: {
    fontSize: 8,
    fontWeight: 500,
    color: '#F0A31C',
    textTransform: 'uppercase',
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  description: {
    fontSize: 10,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  time: {
    fontSize: 10,
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginTop: 4,
  },
  timeIcon: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  emptyIcon: {
    fontSize: 32,
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(1),
  },
  emptyText: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
}));

type EventItemProps = {
  title: string;
  description?: string;
  date: Date;
  time?: string;
};

export const EventItem = ({
  title,
  description,
  date,
  time,
}: EventItemProps) => {
  const classes = useStyles();
  const day = date.getDate();
  const month = date.toLocaleDateString('en-US', { month: 'short' });

  return (
    <Box className={classes.eventItem}>
      <Box className={classes.dateBox}>
        <Typography className={classes.dateDay}>{day}</Typography>
        <Typography className={classes.dateMonth}>{month}</Typography>
      </Box>
      <Box className={classes.content}>
        <Typography className={classes.title}>{title}</Typography>
        {description && (
          <Typography className={classes.description}>{description}</Typography>
        )}
        {time && (
          <Box className={classes.time}>
            <CalendarTodayIcon className={classes.timeIcon} />
            {time}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export const EmptyEvents = () => {
  const classes = useStyles();
  return (
    <Box className={classes.emptyState}>
      <CalendarTodayIcon className={classes.emptyIcon} />
      <Typography className={classes.emptyText}>No upcoming events</Typography>
    </Box>
  );
};
